// Configuration constants

export const maxMessageLength = 1000;
export const maxRecordingDuration = 15;

const apiUrl = process.env.REACT_APP_API_URL;

export const apiEndpoints = {
  chat: `${apiUrl}/chatBot/get-message`,
  generateAudio: `${apiUrl}/chatBot/get-message`,
  leadCapture: `${apiUrl}/botCallLog/bot-lead-capture`,
  chatbot_config: `${apiUrl}/chatBot`,
  chatbot_config_events: `${apiUrl}/chatBot/events/get-slots`,
  feedback: `${apiUrl}/feedback`,
  appointment: `${apiUrl}/chatBot/events/book-slot`, 
  status: `${apiUrl}/user/status`,
  tasks: `${apiUrl}/user/task`, 
  task_update: `${apiUrl}/user/task-update`,
  form: `${apiUrl}/form`,
  formLogin: `${apiUrl}/user/form/login`,
  login: `${apiUrl}/user/login`,
  logout: `${apiUrl}/user/logout`,
  conversations: `${apiUrl}/user/chat-conversations`,
  conversation_messages: (id) => `${apiUrl}/user/chat-conversations-messages?conversation_id=${id}`,
  participants: `${apiUrl}/user/chat-participants`,
  findOrCreateConversation: `${apiUrl}/user/chat-conversations`,
  storeMessage: `${apiUrl}/user/chat-conversations-messages`,
  update: `${apiUrl}/user/update`
};

export const authToken = localStorage.getItem('authToken') || "";
const urlParams = new URLSearchParams(window.location.search);
export const accessToken = urlParams.get('accessToken');

// export const authToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6Ikpva";
// export const accessToken = "eyJpdiI6IlRYYW9QUndRYytSckZJRXhIUGRPTnc9PSIsInZhbHVlIjoiT3dUTFhPRkFtMUZUOXNENU5IbkZXdnFyNW9nakxKL3BtV3ZIRHJYbjlVZzZYNXg3blpPUmlLYU04cThNdHVSN1hpemE1SHFZNVpDdmdjcXVOZ1l0Z0kyd1hucWRiU1VxbkZVL3VtUGc3aXY0UHI5bzIwS3loWTNoQ2owUEYrMjAiLCJtYWMiOiI0MTk4NGM4YWVkNjk1NDAzNzMwZWIwZjczM2E2NDY2NTE4NDQ3NGRkOGQzNjQwYzE1MDU2N2FjODVhYzVmMDYxIiwidGFnIjoiIn0"
// export const formAuthToken = "eyJpdiI6ImpZZWVaa1lGdkl3R0J4cWx6MzZYcFE9PSIsInZhbHVlIjoiVjhqb1JFUEZLRVNLaExWb21UUlowampkcHBXWmZzTlNkNUV4NXQ0YzhlUnlTQ2kvYTZPODNrejluZHg1ZHJWT1dzNmZ4aGR0d0FveHVvbzlRQUx0VUYxS2tVSWNRaDVZeDBKQmJkRVlLNmRLSzFxUFdhUWJaTXRrSHVVVDlGV3p3eDdIcUp5TXI3Z2VnaWhqSDBPTStRPT0iLCJtYWMiOiIxNGQ0NWFiNjNhODE4NjAzYjM3NWMyMmQ0M2IwYTBmNDc0N2EwOWM3MWQyNTUwNWIyOTYyMTQ4OTNkN2UyZDBjIiwidGFnIjoiIn0=";

export const validationRegex = {
  name: /^[a-zA-Z\s]{2,50}$/,
  email: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  phone: /^\+?[1-9]\d{1,14}$/
};

// New custom branding configuration
export const customBranding = {
  color: "#2888b5",
  primaryShadowColor: "#2888b581",
  secondaryColor: "#ffffff",
  warningColor: "#2312e81888b5", 
  sendColor: "#2888b5", 
  toggleStartColor: "#ffffff", 
  footerBtnBgColor: "#ffffff", 
  chatBgColor: "#ffffff", 
  headerTextColor: "#ffffff", 
  msgUserTextColor: "#2a4365", 
  msgBotTextColor: "#", 
  msgUserBgColor: "#dbeafe", 
  msgBotBgColor: "#e0f2fe", 
  audioUserPlayColor: "#368dff", 
  audioBotPlayColor: "#2888b5", 
  audioBotTimeTextColor: "#2888b5",
  audioUserTimeTextColor: "#368dff",
  audioBotTimeStampColor: "#7c838f",
  audioUserTimeStampColor: "#7c838f",
  audioBotTranscriptColor: "#2888b5",
  actionBgColor: "#ffffff",
  actionTextColor: "#39424f",
  SpectrumAnimation: "#3856b8",
  LoadingSpinner: "#3f75ed",
  scrollbarColor: "#2888b5", // Scrollbar color
  scrollbarTrackColor: "#DFE9EB",  // Scrollbar track color
  name: "Bolofy",
  logo_url: "assets/bolofy_round.webp",
};

export const greetingMessage = localStorage.getItem("chatBotData")?.greetingMessage;

export const logo_url = customBranding.logo_url;